import API from '@/api';

const fetchSingleUpload = formData => {
  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
  };
  return fetch(`${API}/panel/upload/`, {
    method: 'POST',
    headers,
    body: formData,
  });
};

export {
  fetchSingleUpload,
}
